export default {"src":"/_next/static/media/holiday.ff0797fe.svg","height":800,"width":800};